import Card from "../Card/Card";
import SkynetIcon from "../Fundamentals/SkynetIcon";
import { ButtonOption} from "../Fundamentals/Button";
import {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {Types} from "../../Constants/FeatureFlags/types";
import {bindActionCreators} from "redux";
import settingsActionsImp from "../../Actions/settingsActions";
import useEditFeatureFlag from "../../Hooks/FeatureFlags/useEditFeatureFlag";
import FeatureFlagTable from "./FeatureFlagTable";
import {useTranslation} from "react-i18next";

function ActiveFlags({ }) {
    const { t } = useTranslation();
    const { enabledFeatureFlags, externalClients, managedTeams, users, selectedFlags, selectedType, selectedId, clearSelected, selectedItem} = useEditFeatureFlag();
    const dispatch = useDispatch();
    const settingsActions = bindActionCreators(settingsActionsImp, dispatch);
    const [effectiveFlags, setEffectiveFlags] = useState([]);

    useEffect(() => {
        const filteredEffectiveFlags = () => {
            return enabledFeatureFlags?.filter(f => {
                if (f.userType === selectedType) return false;
                return (
                    (f.userId === selectedItem.id && f.userType === Types.User) ||
                    (f.userId === selectedItem.teamId && f.userType === Types.Team) ||
                    (f.userId === selectedItem.id && f.userType === Types.Api) ||
                    f.userType === Types.All
                );
            });
        }
        setEffectiveFlags(selectedItem ? filteredEffectiveFlags() : [])
    }, [selectedItem]);

    const filteredFlags = () => {
        let filteredFlags = enabledFeatureFlags;
        
        if (selectedType) {
            filteredFlags = filteredFlags?.filter(flag => flag.userType === selectedType);
        }

        if (selectedId) {
            filteredFlags = filteredFlags?.filter(flag => String(flag.userId) === String(selectedId));
        }

        if (selectedFlags && selectedFlags.length > 0) {
            filteredFlags = filteredFlags?.filter(flag => selectedFlags.includes(flag.name));
        }

        return filteredFlags;
    }
    const deleteFeatureFlag = (e, flagId) => {
        e.stopPropagation();
        settingsActions.deleteFeatureToggle(flagId, () => settingsActions.storeEnabledFeatureFlags(enabledFeatureFlags.filter(f => f.id !== flagId)))
    }
    const refresh = () => {
        clearSelected();
        settingsActions.getEnabledFeatureFlags();
    }
    
    return ( <Card>
        <Card.Header>
            <Card.Header.Title>{t('featureflagscontainer.activefeatureflags')} </Card.Header.Title>
            <Card.Header.Buttons>
                <SkynetIcon icon="vismaicon-refresh" title={"Refresh"} onClick={refresh}/>
            </Card.Header.Buttons>
        </Card.Header>
        <Card.Content isLoading={!enabledFeatureFlags || !externalClients || !managedTeams || !users}>
            <FeatureFlagTable label={selectedItem ? t('featureflagscontainer.explicitflags') : null} flags={filteredFlags()} deleteFeatureFlag={deleteFeatureFlag} deleteButtonOption={selectedItem ? ButtonOption.PRIMARY_DESTRUCTIVE : ButtonOption.DESTRUCTIVE}/>
            {selectedItem && <FeatureFlagTable label={t('featureflagscontainer.inheritedflags')} flags={effectiveFlags} deleteFeatureFlag={deleteFeatureFlag} deleteButtonOption={ButtonOption.DESTRUCTIVE} />}
        </Card.Content>
    </Card>)
}

export default ActiveFlags;